import { createSlice } from "@reduxjs/toolkit";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    activeCountries: [],
    activeAppTheme: null,
    loading: false,
    data: null,
    error: null,
    bullionRates: null,
    appConfig: null,
    carousel: null,
    sipBalance: null,
    kycDetails: null,
    storeList: null,
    diamondPoints: null,
    activeConfigurations: null,
    activeOffers: null,
  },
  reducers: {
    getHoldingsRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getHoldingsSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
    },
    getHoldingsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getBullionRatesRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getBullionRatesSuccess: (state, action) => {
      state.loading = false;
      state.bullionRates = action.payload.data || null;
    },
    getBullionRatesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getAppConfigRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getAppConfigSuccess: (state, action) => {
      state.loading = false;
      state.appConfig = action.payload.data || null;
    },
    getAppConfigFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getCarouselRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getCarouselSuccess: (state, action) => {
      state.loading = false;
      state.carousel = action.payload.data || null;
    },
    getCarouselFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getSipBalanceRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getSipBalanceSuccess: (state, action) => {
      state.loading = false;
      state.sipBalance = action.payload || null;
    },
    getSipBalanceFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getKycDetailsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getKycDetailsSuccess: (state, action) => {
      state.loading = false;
      state.kycDetails = action.payload.data || null;
    },
    getKycDetailsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getStoreListForUserRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getStoreListForUserSuccess: (state, action) => {
      state.loading = false;
      state.storeList = action.payload.data || null;
    },
    getStoreListForUserFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getDiamondPointsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getDiamondPointsSuccess: (state, action) => {
      state.loading = false;
      state.diamondPoints = action.payload.data || null;
    },
    getDiamondPointsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getActiveConfigurationsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getActiveConfigurationsSuccess: (state, action) => {
      state.loading = false;
      state.activeConfigurations = action.payload.data || null;
    },
    getActiveConfigurationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getActiveOffersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getActiveOffersSuccess: (state, action) => {
      state.loading = false;
      state.activeOffers = action.payload.data || null;
    },
    getActiveOffersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getActiveCountriesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getActiveCountriesSuccess: (state, action) => {
      state.loading = false;
      state.activeCountries = action.payload;
      state.message = "Fetched active countries successfully.";
    },
    getActiveCountriesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
     getActiveAppThemeRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getActiveAppThemeSuccess: (state, action) => {
      state.loading = false;
      state.activeAppTheme = action.payload;
      state.message = "Fetched active app theme successfully.";
    },
    getActiveAppThemeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getHoldingsRequest,
  getHoldingsSuccess,
  getHoldingsFailure,
  getBullionRatesRequest,
  getBullionRatesSuccess,
  getBullionRatesFailure,
  getAppConfigRequest,
  getAppConfigSuccess,
  getAppConfigFailure,
  getCarouselRequest,
  getCarouselSuccess,
  getCarouselFailure,
  getSipBalanceRequest,
  getSipBalanceSuccess,
  getSipBalanceFailure,
  getKycDetailsRequest,
  getKycDetailsSuccess,
  getKycDetailsFailure,
  getStoreListForUserRequest,
  getStoreListForUserSuccess,
  getStoreListForUserFailure,
  getDiamondPointsRequest,
  getDiamondPointsSuccess,
  getDiamondPointsFailure,
  getActiveConfigurationsRequest,
  getActiveConfigurationsSuccess,
  getActiveConfigurationsFailure,
  getActiveOffersRequest,
  getActiveOffersSuccess,
  getActiveOffersFailure,
  getActiveCountriesRequest,
  getActiveCountriesSuccess,
  getActiveCountriesFailure,
  getActiveAppThemeRequest,
  getActiveAppThemeSuccess,
  getActiveAppThemeFailure,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
